import { useContext } from "react";
import { Alert, Col, Form, InputGroup, Row, Spinner } from "react-bootstrap";
import ColM from "../../assets/components/column/ColM";
import CreateOrderContext from "../../context/createOrder/";
import { usePricing } from "../../context/pricing/PricingContext";
import RegelsTabel from "./RegelsTabel";

/**
 * Prijsoverzicht.
 *
 * Deze component rekent niets uit: alles wat hier staat komt uit
 * `POST /pricing/calculate`. Alleen de marge is nog een keuze, en ook die wordt
 * door de server verwerkt tot het verkoopadvies.
 *
 * Montage is geen keuze. Er wordt uitsluitend inclusief montage verkocht; de
 * montageregel staat daarom altijd in het overzicht, met een toelichting in
 * plaats van een schakelaar die niets zou doen.
 */
const Assembly = () => {
  const { margin } = useContext(CreateOrderContext);
  const { pricing, loading, error } = usePricing();

  // Bereik van de marge-select: 10 t/m 60 procent.
  const allowedMargin = Array.from(Array(51).keys()).map((i) => i + 10);

  return (
    <>
      <ColM xs={12}>
        {error && (
          <Alert variant="danger" className="mt-2">
            <div style={{ fontWeight: 600 }}>De prijs kon niet worden berekend</div>
            <div>{error}</div>
          </Alert>
        )}

        {pricing && pricing.warnings.length > 0 && (
          <Alert variant="warning" className="mt-2">
            {pricing.warnings.map((w, i) => (
              <div key={i}>{w}</div>
            ))}
          </Alert>
        )}

        {loading && (
          <div className="text-center py-3 text-muted">
            <Spinner animation="border" size="sm" className="me-2" />
            Prijs berekenen…
          </div>
        )}

        {!loading && !pricing && !error && (
          <div className="text-center py-3 text-muted">
            Vul een aantal treden in om de prijs te berekenen.
          </div>
        )}

        {!loading && pricing && <RegelsTabel regels={pricing.lines} />}

        <div className="text-muted" style={{ fontSize: "0.82rem" }}>
          Montage is altijd inbegrepen: Stair Solutions levert uitsluitend
          inclusief montage (inmeten, montagekit en afwerkkit horen daarbij).
        </div>

        <Row>
          <div>
            <hr className="mt-2 mb-2" />
          </div>
          <Form.Group as={Col} xs={12} className="auth-input d-flex flex-row fw-bold">
            <div className="d-flex align-items-center w-100">
              Totaal inkoop (ex BTW)
            </div>
            <InputGroup className="auth-input ">
              <InputGroup.Text
                style={{
                  boxShadow: "none",
                  border: "none",
                  backgroundColor: "transparent",
                  color: "#6c757d",
                }}
                className="fw-bold"
              >
                €
              </InputGroup.Text>
              <Form.Control
                type={"text"}
                className="fw-bold"
                disabled={true}
                value={
                  pricing ? (pricing.totalCents / 100).toFixed(2) : "—"
                }
              />
            </InputGroup>
          </Form.Group>
        </Row>

        <Row>
          <Form.Group as={Col} xs={12} className="auth-input d-flex flex-row">
            <div className="d-flex align-items-center w-100">Totaal inkoop BTW</div>
            <InputGroup className="auth-input ">
              <InputGroup.Text
                style={{
                  boxShadow: "none",
                  border: "none",
                  backgroundColor: "transparent",
                  color: "#6c757d",
                }}
              >
                €
              </InputGroup.Text>
              <Form.Control
                type={"text"}
                disabled={true}
                value={
                  pricing ? (pricing.purchaseVatCents / 100).toFixed(2) : "—"
                }
              />
            </InputGroup>
          </Form.Group>
        </Row>

        <Row>
          <div>
            <hr className="mt-2 mb-2" />
          </div>

          <Form.Group
            as={Col}
            xs={6}
            className="auth-input d-flex flex-row"
            style={{ marginRight: "-12px" }}
          >
            <div className="d-flex align-items-center w-100">Gewenste marge</div>

            <select
              className="select"
              style={{ padding: "8px 4px", position: "inherit" }}
              value={margin.value}
              onChange={(event) => {
                margin.set(Number(event.target.value));
              }}
            >
              {allowedMargin.map((item) => (
                <option value={item} key={item} className="select-item">
                  {item}&#37;
                </option>
              ))}
            </select>
          </Form.Group>

          <Form.Group as={Col} xs={6} className="auth-input ">
            <InputGroup className="auth-input w-100 ">
              <InputGroup.Text
                style={{
                  boxShadow: "none",
                  border: "none",
                  backgroundColor: "transparent",
                  color: "#6c757d",
                }}
              >
                €
              </InputGroup.Text>
              <Form.Control
                type={"text"}
                disabled={true}
                value={
                  pricing ? (pricing.marginCents / 100).toFixed(2) : "—"
                }
              />
            </InputGroup>
          </Form.Group>
        </Row>
      </ColM>

      <ColM xs={12}>
        <Row>
          <Form.Group as={Col} xs={12} className="auth-input d-flex flex-row">
            <div className="d-flex align-items-center w-100 fw-bold">
              Advies verkoopprijs (inc BTW)
            </div>
            <InputGroup className="auth-input ">
              <InputGroup.Text
                style={{
                  boxShadow: "none",
                  border: "none",
                  backgroundColor: "transparent",
                  color: "#6c757d",
                }}
                className="fw-bold"
              >
                €
              </InputGroup.Text>
              <Form.Control
                type={"text"}
                disabled={true}
                className="fw-bold"
                value={
                  pricing
                    ? (pricing.salesInclVatCents / 100).toFixed(2)
                    : "—"
                }
              />
            </InputGroup>
          </Form.Group>
        </Row>
      </ColM>
    </>
  );
};

export default Assembly;
